export default __webpack_public_path__ + "static/media/NotoSansJP-Bold.4ace5489.ttf";